import { useMemo } from 'react';
import useSelectedWeather from '../../../../components/weather/hooks/use-selected-weather';
import { useAppSelector } from '../../../hooks/store-hooks';

export function Watermark() {
    const showWaterMark = useAppSelector((x) => x.user.rights.showWatermark);
    const selectedProducts = useSelectedWeather({
        // Ignore this one to avoid too many updates
        ignoreEvents: ['visibleFrameChanged']
    });

    const loadedWeather = useMemo(
        () => selectedProducts.filter((x) => x.loaded && x.success && x.weatherStore && x.visible),
        [selectedProducts]
    );

    if (!showWaterMark) {
        return null;
    }

    const hasWeather = loadedWeather.length > 0;

    return (
        <img
            alt="watermark"
            className="pe-none input-transparent z-0"
            style={{ position: 'absolute', bottom: hasWeather ? 55 : 0, right: 4, opacity: 0.5, objectFit: 'contain' }}
            height="40"
            src="/img/FEWatermark.png"
        />
    );
}
